module.exports = __webpack_public_path__ + "static/img/preheat_one.bc97b51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preheat_one.png
// module id = 0U3n
// module chunks = 1